/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

const BaseClass = require('gemini/lib/@waca/core-client/js/core-client/ui/core/Class');

const CommonAuthoringFeature = BaseClass.extend({

	init: function(layout) {
		this.layoutView = layout;
		this._events = [
			this.layoutView.model.on('add:item', this.onModelAddItem, this),
			this.layoutView.model.on('remove:item', this.onModelRemoveItem, this)
		];

		this._childrenLayouts = {};
	},

	destroy: function(){
		if(this._events) {
			for (var i = 0; i < this._events.length; i++) {
				if (this._events[i]) {
					this._events[i].remove();
				}
			}
		}
		this._events = null;
		this._destroyChildrenLayouts();
	},
	/**
	 * Called when a new item is added to the model.
	 * Tracks child layout added after creation of this layout - not called if this layout already
	 * had items populated when it was created
	 * @param {object}  Event payload that contains the model to be added.
	 */
	onModelAddItem: function(payload) {
		var modelJson = payload.value.parameter.model;
		var addItemPromise = this.layoutView.layoutController.createLayoutModule(modelJson.id, this.layoutView, { addPayloadData:payload.data });
		addItemPromise.then((layoutView) => {
			// Once the view is created, get the node and add it to the parent view.
			this.layoutView.add(layoutView, payload.value.parameter.insertBefore, payload);
			this._childrenLayouts[layoutView.id] = layoutView;
			layoutView.renderContent({ addPayloadData:payload.data });
		});

		if (this.layoutView.onItemAddDone){
			addItemPromise.then(this.layoutView.onItemAddDone.bind(this.layoutView, payload));
		}

		return addItemPromise;
	},

	/**
	 * Called when a layout model is removed
	 * @param eventPayload
	 */
	onModelRemoveItem: function(eventPayload) {
		var sModelId = eventPayload.value.parameter;
		this._deleteChildLayout(sModelId, eventPayload);
	},

	_deleteChildLayout: function(sModelId, eventPayload) {
		if( !this.layoutView ) {
			console.warn('_deleteChildLayout called for non existent layout ', sModelId, eventPayload);
			return;
		}
		var n = document.getElementById(this.layoutView.getNodeId(sModelId));
		if (n) {
			//legacy child layout
			var layout = n._layout;
			if (layout) {
				if (layout.parentLayout) {
					layout.parentLayout.removeChild(layout, eventPayload);
				}
				layout.destroy(eventPayload);
			}
		} else {
			const layout = this._childrenLayouts[sModelId] || this.layoutView.dashboardApi.getLayout(sModelId).view;
			layout && layout.destroy(eventPayload);
		}

		delete this._childrenLayouts[sModelId];
	},

	_destroyChildrenLayouts: function() {
		Object.entries(this._childrenLayouts).forEach( (entry) =>{
			const layoutId = entry[0];
			const eventPayload = { value: { parameter: layoutId } }; //can we avoid this ??
			this._deleteChildLayout(layoutId, eventPayload);
		});

		this._childrenLayouts = {};
	}
});

//Not using authoring/views/LayoutBaseView as BaseClass to keep things simple
//i.e. const BaseClass = require('gemini/dashboard/layout/authoring/views/LayoutBaseView');
const LayoutBaseAuthoring = BaseClass.extend({

	init: function(options) {
		LayoutBaseAuthoring.inherited('init', this, arguments);

		this.consumeView = options.consumeView; // the consume view
		this.id = this.consumeView.id;
		this.layoutController = this.consumeView.layoutController;
		this.model = this.consumeView.model;
		this.consumeView.authorHelper = this;
		this.consumeView.isAuthoringMode = true;

		this.consumeView.add = this.add.bind(this);
		this.consumeView.remove = this.remove.bind(this);

		this.commonAuthoringFeature = new CommonAuthoringFeature(this.consumeView);
	},

	add: function(layoutView) {
		this.consumeView.addChildRenderMarkup( layoutView.id, layoutView.getRenderMarkup() );
	},
	remove: function(layoutView){
		this.consumeView.removeChildRenderMarkup(layoutView.id);
	},

	destroy: function() {
		this.commonAuthoringFeature.destroy();
		this.consumeView.isAuthoringMode = false;
	}
});

export default LayoutBaseAuthoring;



// WEBPACK FOOTER //
// ./src/js/layout/base/LayoutBaseAuthoring.js